module.exports = __webpack_public_path__ + "static/img/2.9630f71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/zh/2.png
// module id = S09P
// module chunks = 0